import { ReactNode } from 'react'
import { connect } from 'react-redux'

import PageWithBuilding from '../PageWithBuilding'
import { CONNECTION_ERROR } from '../BasePage'

import LoginRegister from '../../components/login/LoginRegister'

import Contractor from '../../components/people/contractor/Contractor'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'

import { getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import { SiNoType, getBoolean } from '../../components/siNo/SiNo'

import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { getAnniCasa, getMaterialiCasa, getTipiCasa, getUtilizziCasa, getStatiCasa } from '../../libs/initialization/remoteInits'

import { HomePageState, HomePageProps, homePageInitialState, homeUpdate } from './HomePageSilce'
import HomeStepTwoo from './HomeStepTwo'
import HomeStepTree from './HomeStepTree'
import * as HomeValidation from './HomeValidation'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class HomePage extends PageWithBuilding<HomePageProps, HomePageState> {

    constructor (props: any) {
        super(props)

        this.state = {
            ...homePageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateMateriali = this.updateMateriali.bind(this)
        this.updateStati = this.updateStati.bind(this)
        
        this.updateMateriale = this.updateMateriale.bind(this)
        this.updateAltri_materiali = this.updateAltri_materiali.bind(this)
        this.updateStato_abitazione = this.updateStato_abitazione.bind(this)
        this.updateAbitazione_principale = this.updateAbitazione_principale.bind(this)
        this.updateSede_lavoro = this.updateSede_lavoro.bind(this)
        this.updateVincolato_belle_arti = this.updateVincolato_belle_arti.bind(this)

        this.updateAssicurazione_incendio = this.updateAssicurazione_incendio.bind(this)
        this.updateAssicurazione_furto = this.updateAssicurazione_furto.bind(this)
        this.updateValore_beni = this.updateValore_beni.bind(this)

        this.updateIsManualAddress = this.updateIsManualAddress.bind(this)

        this.stepTwoValidation = this.stepTwoValidation.bind(this)
        this.stepTreeValidation = this.stepTreeValidation.bind(this)
    }

    componentDidMount() : void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.anni === undefined) {
            getAnniCasa (this.updateAnni, this.manageExpiredSessions)
        }
        if (this.state.materiali === undefined) {
            getMaterialiCasa (this.updateMateriali, this.manageExpiredSessions)
        }
        if (this.state.utilizzi === undefined) {
            getUtilizziCasa (this.updateUtilizzi, this.manageExpiredSessions)
        }
        if (this.state.tipologie === undefined) {
            getTipiCasa (this.updateTipologie, this.manageExpiredSessions)
        }
        if (this.state.stati === undefined) {
            getStatiCasa (this.updateStati, this.manageExpiredSessions)
        }
    }

    render () : ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="home_form">

                                <Pagination
                                    maxPagges={3}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={true}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={false}
                                        validatePage={this.stepTwoValidation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <>
                                            <CommonsPolicyFields 
                                                rilevanza={ this.state.rilevanza }
                                                rilevanzaErrro={ this.state.rilevanzaError }
                                                updateRilevanza={ this.updateRilevanza }

                                                altriSinistri={this.state.altriSinistri}
                                                altriSinistriError={this.state.altriSinistriError}
                                                polizzaAttiva={this.state.polizzaAttiva}
                                                polizzaAttivaError={this.state.polizzaAttivaError}
                                                scadenzaPolizza={this.state.scadenzaPolizza}
                                                scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                                updateAltriSinistri={this.updateAltriSinistri}
                                                updatePloizzaAttiva={this.updatePloizzaAttiva}
                                                updateScadenzaPolizza={this.updateScadenzaPolizza}
                                            />
                                            <HomeStepTwoo 
                                                superfice={this.state.metri_quadri}
                                                uso={this.state.tipo_uso}
                                                tipo={this.state.tipo_immobile}
                                                piani={this.state.numero_piani}
                                                piano={this.state.piano_abitazione}
                                                stati={this.state.stati}
                                                
                                                annoCostruzione={this.state.anno_costruzione}
                                                isRistrutturato={this.state.isRistrutturato}
                                                annoRistrutturazione={this.state.anno_ristrutturazione}

                                                indirizzo={this.state.indirizzo}
                                                street={this.state.street}
                                                street_number={this.state.street_number}
                                                zip={this.state.zip}
                                                city={this.state.city}

                                                is_manual_address={this.state.is_manual_address}
                                                updateManualSelectionCallBack={this.updateIsManualAddress}

                                                materiale={this.state.materiale}
                                                altroMateriale={this.state.altri_materiali}
                                                stato_abitazione={this.state.stato_abitazione}

                                                anni={this.state.anni}
                                                materiali={this.state.materiali}
                                                utilizzi={this.state.utilizzi}
                                                tipologie={this.state.tipologie}

                                                superficeError={this.state.metri_quadriError}
                                                usoError={this.state.tipo_usoError}
                                                tipoError={this.state.tipo_immobileError}
                                                pianiError={this.state.numero_pianiError}
                                                pianoError={this.state.piano_abitazioneError}
                                                
                                                annoCostruzioneError={this.state.anno_costruzioneError}
                                                isRistrutturatoError={this.state.isRistrutturatoError}
                                                annoRistrutturazioneError={this.state.anno_ristrutturazioneError}
                                                annoRistrutturazioneValidationCallback={this.validaeAnnoRistrutturazione}

                                                indirizzoError={this.state.indirizzoError}
                                                streetError={this.state.streetError}
                                                street_numberError={this.state.street_numberError}
                                                zipError={this.state.zipError}
                                                cityError={this.state.cityError}

                                                materialeError={this.state.materialeError}
                                                altroMaterialeError={this.state.altri_materialiError}
                                                stato_abitazioneError={this.state.stato_abitazioneError}

                                                updateSuperficeCallBack={this.updateMetri_quadri}
                                                updateUsoCallBack={this.updateTipo_uso}
                                                updateTipoCallBack={this.updateTipo_immobile}
                                                updatePianiCallBack={this.updateNumero_piani}
                                                updatePianoCallBack={this.updatePiano_abitazione}

                                                updateAnnoCostruzioneCallBack={this.updateAnno_costruzione}
                                                updateIsRistrutturatoCallBack={this.updateIsRistrutturato}
                                                updateAnnoRistrutturazioneCallBack={this.updateAnno_ristrutturazione}

                                                updateAllCallBack={this.updateAll}
                                                updateStreetCallBack={this.updateStreet}
                                                updateNumberCallBack={this.updateStreet_number}
                                                updateZipCallBack={this.updateZip}
                                                updateCityCallBack={this.updateCity}

                                                updateMaterialeCallBack={this.updateMateriale}
                                                updateAltroMaterialeCallBack={this.updateAltri_materiali}
                                                updateStatoAbitazioneCallBack={this.updateStato_abitazione}

                                                expiredSessionCallbak={this.manageExpiredSessions}
                                            />
                                        </>
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 3}
                                        pageNumber={3}
                                        isLast={true}
                                        validatePage={this.stepTreeValidation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <HomeStepTree 
                                            abitazione={this.state.abitazione_principale}
                                            professione={this.state.sede_lavoro}
                                            vincolato_belle_arti={this.state.vincolato_belle_arti}

                                            perizia={this.state.valore_perizia}

                                            assicurazione_incendio={this.state.assicurazione_incendio}
                                            assicurazione_furto={this.state.assicurazione_furto}
                                            valore_beni={this.state.valore_beni}

                                            user={this.state.user}
                                            noMotorPrivacy={this.state.noMotorPrivacy}

                                            abitazioneError={ this.state.abitazione_principaleError}
                                            professioneError={ this.state.sede_lavoroError}
                                            vincolato_belle_artiError={ this.state.vincolato_belle_artiError}

                                            periziaError={this.state.valore_periziaError}

                                            assicurazione_incendioError={this.state.assicurazione_incendioError}
                                            assicurazione_furtoError={this.state.assicurazione_furtoError}
                                            valore_beniError={this.state.valore_beniError}

                                            noMotorPrivacyError={this.state.noMotorPrivacyError}

                                            updateAbitazioneCallBack={ this.updateAbitazione_principale}
                                            updateProfessioneCallBack={ this.updateSede_lavoro}
                                            updateVincolato_belle_artiCallBack={ this.updateVincolato_belle_arti}

                                            updateAssicurazione_incendioCallBack={this.updateAssicurazione_incendio}
                                            updateAssicurazione_furtoCallBack={this.updateAssicurazione_furto}
                                            updateValore_beniCallBack={this.updateValore_beni}

                                            updatePeriziaCallBack={this.updateValore_perizia}

                                            updateNoMotorPrivacyCallBack={this.updateNoMotorPrivacy}

                                            expiredSessionCallbak={this.manageExpiredSessions}
                                        />
                                    </SinglePage>
                                </Pagination>

                            </form>
                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }
    
    getInitialState() {
        return homePageInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {

        return Promise.all([
            this.step1Validation(),
            this.stepTwoValidation(),
            this.stepTreeValidation()
        ]).then ((responses) => {

            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }
            else if (responses[2] !== undefined) {
                p = 3
                e = responses[2]
            }
            
            return {
                errorString: e,
                pageError: p
            }

        }).catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }
    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        const invalidString = 'Valore non valido'

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        } 
        else {
            let superficeErro = undefined
            let usoErro = undefined
            let tipoErro = undefined
            let pianiErro = undefined
            let pianoErro = undefined

            let annoCostruzioneErro = undefined
            let isRistrutturatoErro = undefined
            let annoRistrutturazioneErro = undefined

            let indirizzoErro = undefined
            let materialeErro = undefined
            let altroMaterialeErro = undefined
            let stato_abitazioneErro = undefined

            let abitazioneErro = undefined
            let professioneErro = undefined
            let vincolato_belle_artiErro = undefined
            
            let periziaErro = undefined
            let assicurazione_incendioErro = undefined
            let assicurazione_furtoErro = undefined
            let valore_beniErro = undefined

            let global = undefined

            if (errorString === 'METRI_QUADRI') {
                superficeErro = invalidString
                global = 'Indicare la superficie del immobile'
            }
            else if (errorString === 'TIPO_USO') {
                usoErro = invalidString
                global = "Indicare l'utilizzo del immobile"
            }
            else if (errorString === 'TIPO_IMMOBILE') {
                tipoErro = invalidString
                global = 'Indicare la tipologia del immobile'
            }
            else if (errorString === 'NUMERO_PIANI') {
                pianiErro = invalidString
                global = 'Indicare il numero di piani dello stabile'
            }
            else if (errorString === 'PIANO_ABITAZIONE') {
                pianoErro = invalidString
                global = "Indicare il piano a cui si trova l'immobile"
            }

            else if (errorString === 'ANNO_COSTRUZIONE') {
                annoCostruzioneErro = invalidString
                global = 'Selezionare il periodo di costruzione del immobile'
            }
            else if (errorString === 'IS_RISTRUTTURATO') {
                isRistrutturatoErro = 'Selezionare un valore'
                global = "Indicare se l'immobile è stato ristrutturato"
            }
            else if (errorString === 'ANNO_RISTRUTTURAZIONE') {
                annoRistrutturazioneErro = invalidString
                global = "Indicare l'anno di ristrutturazione del immobile"
            }

            else if (errorString === 'INDIRIZZO' || errorString === 'BUILD_ADDRESS_NOT_FOUND') {
                indirizzoErro = invalidString
                global = (errorString === 'BUILD_ADDRESS_NOT_FOUND') 
                            ? 'Indirizzo non trovato, ti preghiamo di inserirlo tramite il tasto "Compilazione manuale".'
                            : "Indicare l'indirizzo in cui è sito l'immobile"
            }
            else if (errorString === 'MATERIALE') {
                materialeErro = invalidString
                global = "Indicare il materiale principale con cui è stato costruito l'immobile"
            }
            else if (errorString === 'ALTRI_MATERIALI') {
                altroMaterialeErro = invalidString
                global = "Specifcare il materiale principale con cui è stato costruito l'immobile"
            }
            else if (errorString === 'STATO_ABITAZIONE') {
                stato_abitazioneErro = invalidString
                global = "Indicare lo stato del immobile"
            }

            else if (errorString === 'ABITAZIONE_PRINCIPALE') {
                abitazioneErro = invalidString
                global = "Indicare se l'immobile è anche l'abitazione princiaple"
            }
            else if (errorString === 'SEDE_LAVORO') {
                professioneErro = invalidString
                global = "Indicare se l'immobile è anche una sede lavorativa"
            }
            else if (errorString === 'VINCOLO_ARTI') {
                vincolato_belle_artiErro = invalidString
                global = "Indicare se l'immobile è vincolato o tutelato"
            }
            
            
            else if (errorString === 'VALORE_PERIZIA') {
                periziaErro = invalidString
                global = "Indicare il valore dell'immobile"
            }
            else if( errorString === 'ASSICURAZIONE_INCENDIO') {
                assicurazione_incendioErro = invalidString
                global = 'Indicare se si è interssati a una polizza incendio'
            }
            else if( errorString === 'ASSICURAZIONE_FURTO') {
                assicurazione_furtoErro = invalidString
                global = 'Indicare se si è interssati a una polizza furto'
            }
            else if( errorString === 'VALORE_BENI') {
                valore_beniErro = invalidString
                global = 'Indicare il valore dei beni custoditi nel immobile'
            }
            
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                metri_quadriError: superficeErro,
                tipo_usoError: usoErro,
                tipo_immobileError: tipoErro,
                numero_pianiError: pianiErro,
                piano_abitazioneError: pianoErro,

                anno_costruzioneError: annoCostruzioneErro,
                isRistrutturatoError: isRistrutturatoErro,
                anno_ristrutturazioneError: annoRistrutturazioneErro,

                indirizzoError: indirizzoErro,

                materialeError: materialeErro,
                altri_materialiError: altroMaterialeErro,
                stato_abitazioneError: stato_abitazioneErro,

                abitazione_principaleError: abitazioneErro,
                sede_lavoroError: professioneErro,
                vincolato_belle_artiError: vincolato_belle_artiErro,
                
                valore_periziaError: periziaErro,
                assicurazione_incendioError: assicurazione_incendioErro,
                assicurazione_furtoError: assicurazione_furtoErro,
                valore_beniError: valore_beniErro,
                
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        const isAltroMateriale = this.state.materiale === 'altro'
        const hasBeni = this.state.assicurazione_incendio === true || this.state.assicurazione_furto === true

        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            metri_quadri: this.state.metri_quadri ?? null,
            tipo_uso: this.state.tipo_uso ?? null,
            tipo_immobile: this.state.tipo_immobile ?? null,
            numero_piani: this.state.numero_piani ?? null,
            piano_abitazione: this.state.piano_abitazione ?? null,
            anno_costruzione: this.state.anno_costruzione ?? null,
            anno_ristrutturazione: (this.state.isRistrutturato === true) ? (this.state.anno_ristrutturazione ?? null) : null,
            
            indirizzo: this.state.indirizzo ?? null,
            materiale: this.state.materiale ?? null,
            altri_materiali: isAltroMateriale ? (this.state.altri_materiali ?? null) : null,
            stato_abitazione: this.state.stato_abitazione ?? null,

            abitazione_principale: this.state.abitazione_principale ?? null,
            sede_lavoro: this.state.sede_lavoro ?? null,
            vincolato_belle_arti: this.state.vincolato_belle_arti ?? null,
            
            valore_perizia: this.state.valore_perizia ?? null,
            assicurazione_incendio: this.state.assicurazione_incendio ?? null,
            assicurazione_furto: this.state.assicurazione_furto ?? null,
            valore_beni: hasBeni ? (this.state.valore_beni ?? null) : null
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    homeUpdate (this.state)
                )
            }
        )
    }

    // -- solo del preventivatore
    private updateMateriali (resp: any) {
        this.setState ({
            materiali: resp
        })
    }
    private updateStati (resp: any) {
        this.setState({
            stati: resp
        })
    }
    
    private updateMateriale (val: string | undefined) {
        this.saveStateAndRedux({
            materiale: val,
            materialeError: undefined,
            altri_materiali: (val !== 'altro') ? undefined : this.state.altri_materiali
        })
    }
    private updateAltri_materiali (val: string | undefined) {
        this.saveStateAndRedux({
            altri_materiali: val,
            altri_materialiError: undefined
        })
    }
    private updateStato_abitazione (val: string | undefined) {
        this.saveStateAndRedux({
            stato_abitazione: val,
            stato_abitazioneError: undefined
        })
    }
    
    private updateAbitazione_principale (val: SiNoType) {
        this.saveStateAndRedux({
            abitazione_principale: getBoolean( val ),
            abitazione_principaleError: undefined
        })
    }
    private updateSede_lavoro (val: SiNoType) {
        this.saveStateAndRedux({
            sede_lavoro: getBoolean( val ),
            sede_lavoroError: undefined
        })
    }
    private updateVincolato_belle_arti (val: SiNoType) {
        this.saveStateAndRedux({
            vincolato_belle_arti: getBoolean( val ),
            vincolato_belle_artiError: undefined
        })
    }

    private updateAssicurazione_incendio (val: SiNoType) {
        const boolVal = getBoolean( val )
        const corelateVal = this.state.assicurazione_furto

        let next = {
            assicurazione_incendio: getBoolean( val ),
            assicurazione_incendioError: undefined
        }

        if (!boolVal && ! corelateVal) {
            next = {
                ...next,
                ...{ valore_beni: undefined, valore_beniError: undefined }
            }
        }

        this.saveStateAndRedux( next )
    }
    private updateAssicurazione_furto (val: SiNoType) {
        const boolVal = getBoolean( val )
        const corelateVal = this.state.assicurazione_incendio

        let next = {
            assicurazione_furto: getBoolean( val ),
            assicurazione_furtoError: undefined
        }

        if (!boolVal && ! corelateVal) {
            next = {
                ...next,
                ...{ valore_beni: undefined, valore_beniError: undefined }
            }
        }

        this.saveStateAndRedux( next )
    }
    private updateValore_beni (val: number | undefined) {
        this.saveStateAndRedux({
            valore_beni: val,
            valore_beniError: undefined
        })
    }

    private updateIsManualAddress ( val: boolean) {
        this.setState({
            is_manual_address: val
        })
    }

    private async stepTwoValidation () {
        const error = this.commonStep2Validation()

        if (error) {
            this.printError(error, false, 2)
            return error
        }

        return HomeValidation.stepTwoValidation (
                this.state.altriSinistri,
                this.state.polizzaAttiva,
                this.state.scadenzaPolizza,

                this.state.metri_quadri,
                this.state.tipo_uso,
                this.state.tipo_immobile,
                this.state.numero_piani,
                this.state.piano_abitazione,
                this.state.anno_costruzione,
                this.state.anno_ristrutturazione,

                this.state.indirizzo,
                this.state.is_manual_address,
                
                this.state.materiale,
                this.state.altri_materiali,
                this.state.stato_abitazione,

                this.printError,
                this.manageExpiredSessions
            )
    }

    private async stepTreeValidation () {
        return HomeValidation.stepTreeValidation (
                this.state.abitazione_principale,
                this.state.sede_lavoro,
                this.state.vincolato_belle_arti,
                this.state.valore_perizia,
                this.state.assicurazione_incendio,
                this.state.assicurazione_furto,
                this.state.valore_beni,

                this.state.user,
                getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                
                this.printError,
                this.manageExpiredSessions
            )
    }
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    metri_quadri: state.metri_quadri,
    tipo_uso: state.tipo_uso,
    tipo_immobile: state.tipo_immobile,
    numero_piani: state.numero_piani,
    piano_abitazione: state.piano_abitazione,
    anno_costruzione: state.anno_costruzione,
    isRistrutturato: state.isRistrutturato,
    anno_ristrutturazione: state.anno_ristrutturazione,
    indirizzo: state.indirizzo,
    materiale: state.materiale,
    altri_materiali: state.altri_materiali,
    stato_abitazione: state.stato_abitazione,
    abitazione_principale: state.abitazione_principale,
    sede_lavoro: state.sede_lavoro,
    vincolato_belle_arti: state.vincolato_belle_arti,
    valore_perizia: state.valore_perizia,
    assicurazione_incendio: state.assicurazione_incendio,
    assicurazione_furto: state.assicurazione_furto,
    valore_beni: state.valore_beni,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user,

    actualPage: state.actualPage,
  }
}

export default connect(mapState) (HomePage)